import BusinessOverviewWidget from "../../overview/BusinessOverviewWidget.js";
import chartBuilder from "../../../core/charts.js";

/**
 * `businessOverviewReportWidget` is a subclass of `businessOverviewWidget`
 * with a specific behavior for plotband click.
 */
export default class BusinessOverviewReportWidget extends BusinessOverviewWidget {
	renderContentOn(html) {
		html.div({ klass: "business-overview-report" }, (html) =>
			super.renderContentOn(html),
		);
	}

	_setup() {
		super._setup();

		this._chartOptions.plotOptions.series = chartBuilder
			.seriesPlotOptions()
			.setPoint(this._pointMarker)
			.setSelectablePoints({
				onClick: (point) => this._updatePopup(point),
			})
			.build();
	}

	_onPlotbandClick(plotBand) {
		this._updatePopup(plotBand);
	}

	_updatePopup(element) {
		const period = element.options.period;
		if (this._highchart) {
			this._highchart.series[1].points.forEach((point) => {
				if (period.includes(new Date(point.x))) {
					point.update(this._pointMarkerSelected, false);
				} else {
					point.update(this._pointMarker, false);
				}
			});
		}
		this._highchart.series[1].update({}, true);
	}
}
